import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useSearchParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SegmentMenu from "../../../../components/navegation/SegmentMenu";
import Payments from "./Payments";
import Payouts from "./Payouts";
import {
  clearSegments,
  setSegments,
} from "../../../../store/redux_auth/authSlice";

const AccountPaymentPayouts = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const hasConnectedAccount = !!user?.stripe_connected_account;
  const currentSection = searchParams.get("section") || "payments";
  const [isMounting, setIsMounting] = useState(true);

  // Redirect to default section if no parameters
  useEffect(() => {
    if (!searchParams.get("section")) {
      navigate("/account/transactions?section=payments", { replace: true });
    }
  }, [searchParams, navigate]);

  // Redirect to payments if user tries to access payouts without connected account
  useEffect(() => {
    if (currentSection === "payouts" && !hasConnectedAccount) {
      navigate("/account/transactions?section=payments", { replace: true });
    }
  }, [currentSection, hasConnectedAccount, navigate]);

  // Segment configuration for Account Transactions
  // Only show Payouts segment if user has connected account
  const transactionSegments = useMemo(() => {
    const segments = [
      {
        path: "/account/transactions?section=payments",
        text: "Payments",
        normalIcon: `${process.env.PUBLIC_URL}/images/icons/history_grey.svg`,
        activeIcon: `${process.env.PUBLIC_URL}/images/icons/history_blue.svg`,
      },
    ];

    // Add Payouts segment only if user has connected account
    if (hasConnectedAccount) {
      segments.push({
        path: "/account/transactions?section=payouts",
        text: "Payouts",
        normalIcon: `${process.env.PUBLIC_URL}/images/icons/payout_grey.svg`,
        activeIcon: `${process.env.PUBLIC_URL}/images/icons/payout_blue.svg`,
      });
    }

    return segments;
  }, [hasConnectedAccount]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsMounting(false);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Push the segments to the global Bottom Nav
    dispatch(setSegments(transactionSegments));

    // Clean up when leaving the page
    return () => dispatch(clearSegments());
  }, [dispatch, transactionSegments]);

  return (
    <div className="main-content-area">
      <div className="content">
        <div className="ich-wrapper">
          <div className="internal-content-header">
            <SegmentMenu
              segments={transactionSegments}
              currentPath={location.pathname + location.search}
              loading={isMounting}
            />
          </div>
        </div>
        {currentSection === "payments" ? (
          <Payments />
        ) : hasConnectedAccount ? (
          <Payouts />
        ) : (
          <Payments />
        )}
      </div>
    </div>
  );
};

export default AccountPaymentPayouts;
